import { ConsoleLogger, LogLevel } from 'amazon-chime-sdk-js';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { ChimeActions } from 'src/app/features/video-conference/chime/store';

export class CustomChimeLogger extends ConsoleLogger {
  constructor(name: string, level: LogLevel, readonly store: Store) {
    super(name, level);
  }

  warn(message: string): void {
    if (!environment.production) {
      super.warn(message);
    }

    this.store.dispatch(
      ChimeActions.SendWarningLogToLogger({
        payload: { message },
      })
    );
  }

  error(message: string): void {
    super.error(message);

    this.store.dispatch(
      ChimeActions.SendErrorLogToLogger({
        payload: { message },
      })
    );
  }
}
